import { StageScreen } from "../../features/stage";

/** FS-SB 기구 무대 — 페이지는 조립만 한다(CSG 4.2). 화면 본체는 features/stage */
export default function StagePage() {
  return <StageScreen />;
}
